/* global workbox */

// Basic service worker registration for Vue CLI PWA
if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .catch(() => {});
    });
  }
}


